// Dependencies
import Roadmap from '../components/Roadmap';

function RoadmapPage()
{
    return(
        <Roadmap />
    );
}

export default RoadmapPage;